import { backendClient } from '../lib/api/backendClient';

export type AppEventLevel = 'info' | 'warn' | 'error';

export type AppEventPayload = {
  eventName: string;
  level?: AppEventLevel;
  userId?: string | null;
  message?: string | null;
  stack?: string | null;
  context?: Record<string, unknown> | null;
  requestId?: string | null;
  appVersion?: string | null;
};

const sanitizeContext = (context: Record<string, unknown> | null | undefined) => {
  if (!context) return undefined;
  try {
    return JSON.parse(JSON.stringify(context));
  } catch {
    return undefined;
  }
};

export const logAppEvent = async (payload: AppEventPayload): Promise<void> => {
  const body = {
    ...payload,
    userId: payload.userId ?? undefined,
    context: sanitizeContext(payload.context),
  };

  try {
    await backendClient.post('/api/app-events', body);
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[appEvents] Failed to record event', error);
    }
  }
};
